
import request from './request';

import { API_ENDPOINT } from './api';

export const requestAssetImage = (asset) => {
  return new Promise(resolveAssetImage => {
    request(`${API_ENDPOINT}${asset.urlImagemAtivo}`, {
      responseType: 'blob'
    })
    .then(async response => {
      if (response.size) {
        var reader = new window.FileReader();
        reader.readAsDataURL(response);
        reader.onload = () => {
          resolveAssetImage(reader.result);
        }
      } else {
        resolveAssetImage(null);
      }
    });
  });
};

const ASSETS_IMAGES_KEY = 'assetsImages';

const setItemInLocalStorage = (key, value) => {
  return new Promise(resolve => {
    localStorage.setItem(key, value);
    resolve(value);
  });
};

const saveImageInStorage = async ({ image, name }) => {
  const storagedImages = await getItemInLocalStorage(ASSETS_IMAGES_KEY) || [];
  const imageToSave = { image, name };
  storagedImages.push(imageToSave);

  const saveImage = await setItemInLocalStorage(ASSETS_IMAGES_KEY, JSON.stringify(storagedImages));
  return saveImage;
};

const getItemInLocalStorage = (key) => {
  return new Promise(resolve => {
    const storagedItem = JSON.parse(localStorage.getItem(key))
    resolve(storagedItem);
  });
};

export const getAssetImage = async (asset)  => {
  const storagedImages = await getItemInLocalStorage(ASSETS_IMAGES_KEY);
  const assestImage = storagedImages?.find(image => asset == image.name)?.image;

  if (assestImage) {
    return assestImage;
  }

  return null;
};

export const saveImagesInLocalStorage = (assets) => {
  const promises = [];
  assets.forEach(async asset => {
    const promise = new Promise(async resolve => {

      const storagedAssetImage = await getAssetImage(asset.nome);

      if (storagedAssetImage) {
        resolve(storagedAssetImage);
      } else {
        const image = await requestAssetImage(asset);

        if (image) {
          const saveSuccess = await saveImageInStorage({ image, name: asset.nome });
          resolve(saveSuccess);
        }
        resolve(null);
      }
    });
    promises.push(promise);
  });

  return Promise.all(promises);
};
